import { render, staticRenderFns } from "./TournamentPicker.vue?vue&type=template&id=9b6f8a88&"
import script from "./TournamentPicker.vue?vue&type=script&lang=js&"
export * from "./TournamentPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports